import ChecklistTabs, { type ChecklistTab } from '@univdiam/ui/customComponents/OrderDetail/ChecklistTabs';
import { useOrderChecklist, useOrderChecklistMutations } from '@/sharedData/OrderChecklist';
import type { OrderType } from '@/types';

const OrderChecklist = ({ orderDetailData }: { orderDetailData: OrderType }) => {
  const { data, isLoading } = useOrderChecklist(orderDetailData?.id?.toString());
  const tabs = (data?.data?.data ?? []) as ChecklistTab[];
  const {
    createTab,
    renameTab,
    deleteTab,
    pasteTabs,
    createItem,
    toggleItem,
    updateItem,
    reorderItems,
    deleteItem
  } = useOrderChecklistMutations(orderDetailData?.id?.toString());

  return (
    <ChecklistTabs
      tabs={tabs}
      isAdmin={true}
      isLoading={isLoading}
      onAddTab={(tab_name) => createTab.mutateAsync(tab_name)}
      onRenameTab={(tab, tab_name) => renameTab.mutateAsync({ id: tab.id, tab_name })}
      onDeleteTab={(tabId) => deleteTab.mutateAsync(tabId)}
      onAddItem={(tabId, title) => createItem.mutateAsync({ tab_id: tabId, title })}
      onToggleItem={(item, checked) => toggleItem.mutate({ id: item.id, is_checked: checked })}
      onEditItem={(item, title) => updateItem.mutateAsync({ id: item.id, title })}
      onReorderItems={(tabId, itemIds) => reorderItems.mutateAsync({ tab_id: tabId, item_ids: itemIds })}
      onDeleteItem={(itemId) => deleteItem.mutateAsync(itemId)}
      onPasteTabs={(tabsToPaste) => pasteTabs.mutateAsync(tabsToPaste)}
    />
  );
};

export default OrderChecklist;
